<template>
  <div>
    <div
      :class="[
        'container-fluid',
        'headerImage',
        {
          headerImage_lg_md: ['lg', 'md'].includes($mq),
          headerImage_md__lt: ['sm', 'xs'].includes($mq),
        },
      ]"
    >
      <div class="container h-100">
        <b-row class="d-flex align-items-center h-100">
          <b-col class="header-col">
            <div class="header-content">
              <h4 style="font-size: 1.1rem; line-height: 1.5rem;">
                <template v-if="['sm', 'xs'].includes($mq)">
                  {{ $t('COMPONENT_imageHead_marketing_short') }}
                </template>
                <template v-else>
                  {{ $t('COMPONENT_imageHead_marketing') }}
                </template>
              </h4>
            </div>
          </b-col>
        </b-row>
      </div>
    </div>
    <div class="container">
      <div class="row mt-4">
        <div class="col pt-3">
          <h5>{{ $t('PAGE_home_intro_title') }}</h5>
          <p>{{ $t('PAGE_home_intro_description') }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
export default {
  name: 'imageHead',
  computed: {
    ...mapState(['language']),
  },
};
</script>

<style lang="scss" scoped>
.headerImage {
  height: 400px;
  overflow: hidden;
  background-position: left;
  background-size: cover;
  background-image: url('../assets/headerbild.jpg');

  & .header-col {
    background-color: rgba(255, 255, 255, 0.6);
    border-radius: 3px;
    margin-left: 40%;
  }

  & .header-content {
    padding: 40px 25px 25px 25px;
  }
}

.headerImage_lg_md {
  height: 250px;

  & .header-content {
    padding: 30px 25px 15px 25px;
  }
}

.headerImage_md__lt {
  height: initial;
  background-image: url('../assets/headerbild-mobile.jpg');

  & .header-col {
    border-radius: initial;
    margin-left: initial;
    background-color: rgba(255, 255, 255, 0.8);
  }

  & .header-content {
    padding: 50px 25px 25px;
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ImageHead.vue